export default __webpack_public_path__ + "static/media/sass.3a8aedc4.png";